import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
} from '@mui/material';
import React from 'react';
import EditUser from 'renderer/features/settings/components/EditUser';
import { formatQueryError } from 'renderer/shared/formatters/formatters';
import AdminEditPassword from './AdminEditPassword';
import {
  useAdminDeactivateAccountMutation,
  useAdminVerifyAccountMutation,
} from '../services/users.endpoints';

interface EditUserDetailsDialogProps {
  userId: string;
  open: boolean;
  onClose: () => void;
  activated: boolean;
}

const EditUserDetailsDialog: React.FC<EditUserDetailsDialogProps> = ({
  userId,
  open,
  onClose,
  activated,
}) => {
  const [
    verifyAccount,
    { isLoading: verifyLoading, error: verifyError, data: verifyResponse },
  ] = useAdminVerifyAccountMutation();
  const [
    deactivateAccount,
    {
      isLoading: deactivateLoading,
      error: deactivateError,
      data: deactivateResponse,
    },
  ] = useAdminDeactivateAccountMutation();

  const isLoading = verifyLoading || deactivateLoading;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <EditUser userId={userId} />
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <AdminEditPassword userId={userId} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        {verifyError && (
          <Alert severity="error">{formatQueryError(verifyError)}</Alert>
        )}
        {deactivateError && (
          <Alert severity="error">{formatQueryError(deactivateError)}</Alert>
        )}
        {verifyResponse && (
          <Alert severity="success">{verifyResponse.message}</Alert>
        )}
        {deactivateResponse && (
          <Alert severity="success">{deactivateResponse.message}</Alert>
        )}
        <Button
          variant="outlined"
          onClick={() => verifyAccount({ userId })}
          disabled={isLoading || activated}
        >
          Activate Account
        </Button>
        <Button
          variant="outlined"
          color="error"
          onClick={() => deactivateAccount({ userId })}
          disabled={isLoading}
        >
          Deactivate Account
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditUserDetailsDialog;
